import { getApi, getEncodedSearchString } from "../../common/actions/net.js";
import { getExistingProductImage, loadProductImage } from "./productImage.js";
import { messageType, pushSystemMessage } from "../../common/actions/systemMessage.js";

import Logger from "../../common/util/Logger.js";
import { getInvoiceDetails } from "./history.js";

export const SET_QUERY_RESAULTS = "SET_QUERY_RESAULTS";
export const ADD_QUERY_RESAULTS = "ADD_QUERY_RESAULTS";
export const SET_QUERY_PRODUCT_IMAGE_URL = "SET_QUERY_PRODUCT_IMAGE_URL";
export const QUERY_IS_LOADING = "QUERY_IS_LOADING";
export const QUERY_DONE_LOADING = "QUERY_DONE_LOADING";
export const QUERY_FAILED_LOADING = "QUERY_DONE_LOADING";
export const EDIT_QUERY_FILTER = "EDIT_QUERY_FILTER";
export const CLEAR_QUERY_RESAULTS = "CLEAR_QUERY_RESAULTS";
export const QUERY_ALL_RESAULTS_LOADED = "QUERY_ALL_RESAULTS_LOADED";
export const SET_QUERY_OPTION = "SET_QUERY_OPTION";

const addQueryResaults = (productsArray, startIndex) => ({
    type: ADD_QUERY_RESAULTS,
    resaults: productsArray,
    startIndex,
});

const setQueryProductImageUrl = (index, imageUrl) => ({
    type: SET_QUERY_PRODUCT_IMAGE_URL,
    index,
    imageUrl
});


const setQueryIsLoading = () => ({
    type: QUERY_IS_LOADING,
});
const setQueryDoneLoading = () => ({
    type: QUERY_DONE_LOADING,
});
const setQueryFailedLoading = () => ({
    type: QUERY_FAILED_LOADING,
});

const setQueryAllResaultsLoaded = () => ({
    type: QUERY_ALL_RESAULTS_LOADED,
});

/**
 * Downloads more search resaults on active query
 * @param {object} productQuery 
 * @param {object} productImage
 * @param {number} noOfProducts
 * @param {number} invoiceId
 * @returns {func}
 */
export function loadMoreSearchedProducts(productQuery, productImage, noOfProducts=50, invoiceId=0){
    return async (dispatch) => {
        try {
            //make sure there is something new to load
            if( productQuery.allResaultsLoaded ){
                return true;
            }

            //start collection new lines
            dispatch( setQueryIsLoading() );
            
            if(invoiceId > 0)
            {
                dispatch(getInvoiceDetails(invoiceId, productQuery.filter.searchString));
            }  
            else
            {
                const startIndex = productQuery.resaults.length;
                //load in more products
                const {payload} = await dispatch(getApi("Product/ProductFreeTextQuery", {
                    customerId: productQuery.filter.customerId,
                    noOfProducts: noOfProducts,
                    startIndex: startIndex,
                    freeText:  getEncodedSearchString(productQuery.filter.searchString),
                    ReturnTobacco: productQuery.filter.ReturnTobacco ? true : false,
                    ProductsForClaim: productQuery.filter.ProductsForClaim ? true : false,
                    OnlyCampaigns: productQuery.filter.OnlyCampaigns ? true : false,
                    OnlyNews: productQuery.filter.OnlyNews ? true : false,
                    OnlyLastSold: productQuery.filter.OnlyLastSold ? true : false,
                    SupplierId: productQuery.filter.SupplierId? productQuery.filter.SupplierId : undefined,
                    //SupplierParentId: productQuery.filter.SupplierId? productQuery.filter.SupplierId : undefined,
                    ProductGroupId: productQuery.filter.ProductGroupId? productQuery.filter.ProductGroupId : undefined,
                    SortingColumn : productQuery.filter.SortingColumn? productQuery.filter.SortingColumn : undefined,
                    SortDescending: productQuery.filter.SortDescending ? true : false,
                }));
    
                //check if all data has been loaded
                if( payload.length!=noOfProducts ){
                    dispatch( setQueryAllResaultsLoaded() );
                }
    
                //insert existing images
                for(let i=0; i<payload.length; i++){
                    payload[i].imageUrl = getExistingProductImage(payload[i].productId);
                }
    
                //convert to default layout
                const prdList = payload.map( (prd) => {return {product:prd};});
                
                //store query resaults
                await dispatch( addQueryResaults(prdList,startIndex,noOfProducts) );
    
                //download all images not already inserted
                for(let index=0; index<prdList.length; index++) {
                    if( !prdList[index].product.imageUrl || prdList[index].product.imageUrl.length===0 ) {
                        const callback = (imageUrl) => dispatch( setQueryProductImageUrl(startIndex+index, imageUrl) );
                        dispatch( loadProductImage(productImage, prdList[index].product.productId, prdList[index].product.imageFileName, callback) );
                    }
                }
    

            }

          
            dispatch( setQueryDoneLoading() );
        } catch (error) {
            dispatch( setQueryFailedLoading() );
            dispatch(pushSystemMessage(error && error.message || "Søket mislyktes", messageType.error));

            if(error.message === "Ukjent vare" || error.message === "Ikke tilgjengelig" || error.message === "Utgått av sortimentet")
            {
                await dispatch({
                    type: EDIT_QUERY_FILTER,
                    change: { searchString: "" },
                });

                return false;
            }

            Logger.error(error);
            return true;
        }
    };
}

/**
 * Changes the query filter
 * @param {object} productQuery 
 * @param {object} productImage
 * @param {object} change
 * @param {func}   callback // function will be called when the state has been updated
 * @returns {func}
 */
export function editQueryFilter(productQuery, productImage, change, callback){
    return async (dispatch) => {
        await dispatch({
            type: EDIT_QUERY_FILTER,
            change
        });

        try {
            dispatch( setQueryIsLoading() );

            const res = await callback();

            if (res === false)
            {
                callback();
            } 

        } catch (error) {
            Logger.error(error);
        } finally {
            dispatch( setQueryDoneLoading() );
        }
    };
}

/**
 * Changes the query filter
 * @returns {func}
 */
export function clearQuery(){
    return async (dispatch) => {
        dispatch({
            type: CLEAR_QUERY_RESAULTS,
        });
    };
}

/**
 * Changes the query filter
 * @param {object} returnTobacco 
 * @returns {func}
 */
export function prepareQueryOptions(returnTobacco){
    return async (dispatch) => {
        const payloadGroup = await dispatch( getApi("Product/ProductGroupQuery", { ReturnTobacco: returnTobacco ? true : false }) );
        const payloadSupplier = await dispatch( getApi("Product/SupplierNamesQuery", { ReturnTobacco: returnTobacco ? true : false }) );
        dispatch({
            type: SET_QUERY_OPTION,
            productGroups: payloadGroup ? payloadGroup.payload : null,
            productSuppliers: payloadSupplier ? payloadSupplier.payload : null,
        });
    };
}